<template>
    <div class="Footer-wrapper">
        <div class="Footer-items">
            <div class="contain clearFix">
                <div class="Footer-info">
                    <a href="/" class="Footer-logo" ondragstart="return false"><img src="@/assets/images/logoH.png" alt="" class="full-maxWidth" ondragstart="return false"></a>
                    <div class="Footer-rel mt18">
                        <p style="padding: 15px 0;">售前服务热线</p>
                        <div class="phone fs20">+853 28335475</div>
                        <p style="padding: 15px 0;" class="mt16">公司地址</p>
                        <div class="add">广东省珠海横琴粤澳深度合作区跨境电商(华发)创新产业园2栋 401-2</div>
                    </div>
                    <div class="FooterCode mt24">
                        <a href="javascript:void(0);" ondragstart="return false" @mouseover="showImageTip = true" @mouseleave="showImageTip = false">
                            <img src="@/assets/images/Ficon5W.svg" alt="" ondragstart="return false">
                            <div class="FooterCode-img" v-if="showImageTip">
                                <img src="@/assets/images/wx-qrcode.jpg" />
                            </div>
                        </a>
                        <!-- <a href="" target="_blank" ondragstart="return false">
                            <img src="/template/default/images/common/Ficon11W.svg" alt="" ondragstart="return false">
                        </a>
                        <a href="tencent://message/?uin=123456&amp;Menu=yes" class="qq" ondragstart="return false">
                            <img src="/template/default/images/common/Ficon6W.svg" alt="" ondragstart="return false">
                        </a> -->
                    </div>
                </div>
                <div class="Footer-navbar">
                    <ul>
                        <li>
                            <div class="Footer-menu">
                                产品服务
                            </div>
                            <div class="Footer-drop">
                                <a href="" ondragstart="return false">星火·链网子链建设服务</a> <a href="" ondragstart="return false">星火·链网子链接入服务</a> <a href="" ondragstart="return false">公共资源服务</a> <a href="" ondragstart="return false">公共数据服务</a> <a href="" ondragstart="return false">BID标识服务</a> <a href="" ondragstart="return false">可信身份认证服务</a> <a href="" ondragstart="return false">跨链互操作服务</a> 
                            </div>
                        </li>
                        <li>
                            <div class="Footer-menu">
                                平台服务
                            </div>
                            <div class="Footer-drop">
                                <a href="" ondragstart="return false">电子印章平台</a> <a href="" ondragstart="return false">产品溯源唯真</a> <a href="" ondragstart="return false">湾区学历认证</a> <a href="" ondragstart="return false">农业金融服务</a> <a href="" ondragstart="return false">生态合作</a> 
                            </div>
                        </li>
                        <li>
                            <div class="Footer-menu">
                                关于我们
                            </div>
                            <div class="Footer-drop">
                                <a href="https://www.guiamacau.com/about" ondragstart="return false">横琴粤澳链</a> <a href="https://www.guiamacau.com/about" ondragstart="return false">融贯国际</a> <a href="https://www.guiamacau.com/about" ondragstart="return false">浪潮云</a><a href="https://www.guiamacau.com/about" target="_blank" ondragstart="return false">泰尔英福</a> 
                            </div>
                        </li>
                                            
                        <li>
                            <div class="Footer-menu">新闻资讯</div>
                            <div class="Footer-drop">
                                
                                <a href="/News/1" ondragstart="return false">最新资讯</a>
                                
                                <a href="/News/1" ondragstart="return false">行业动态</a>
                                
                                <a href="/News/1" ondragstart="return false">技术前沿</a>
                                
                                <a href="/News/1" ondragstart="return false">大事记</a>
                                
                                
                            </div>
                        </li>
        
                    </ul>
                </div>
                <div class="Footer-link mt40">
                    <div class="title">友情链接：</div>
                    <ul>
                        
                        <li><a href="https://www.miit.gov.cn/" target="_blank" ondragstart="return false">工业和信息化部</a></li>
                        
                        <li><a href="http://www.aii-alliance.org/" target="_blank" ondragstart="return false">工业互联网产业联盟</a></li>
                        
                        <li><a href="https://www.miit.gov.cn/ztzl/rdzt/gyhlw/index.html" target="_blank" ondragstart="return false">工业互联网（工信部）</a></li>
                        
                        <li><a href="http://www.caict.ac.cn/" target="_blank" ondragstart="return false">中国信息通信研究院</a></li>
                        
                        <li><a href="https://bitfactory.cn/" target="_blank" ondragstart="return false">星火·链网</a></li>
                        
                        <li><a href="https://www.inspur.com/" target="_blank" ondragstart="return false">浪潮官网</a></li>
                        
                        <li><a href="https://mid.guiamacau.com/mid-admin-web/#/" target="_blank" ondragstart="return false">MID溯源平台</a></li>
                        
                        
                    </ul>
                </div>
            </div>
        </div>
        <div class="Footer-copyright">
            <div class="contain clearFix">
                <h6>copyright © 2021 珠海横琴融贯国际科技发展有限公司  <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021169012号</a></h6>
                <div class="Footer-page">
                    <a href="">隐私政策</a> | <a href="">服务协议</a>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
  currentActive: {
    type: String,
    default: ''
  }
});

const showImageTip = ref(false)
</script>

<style scoped>
.Footer-wrapper {
    width: 100%;
    background: #132c56;
    position: relative;
    z-index: 9;
    color: #FFFFFF;
}
.Footer-items {
    width: 100%;
    padding: 80px 0 24px;
}
.Footer-items {
    padding-top: 60px;
}
.clearFix:before, .clearFix:after {
    display: table;
    content: "";
}
.contain {
    margin: 0 auto;
    width: 1200px;
    overflow: hidden;
}
.Footer-info {
    float: right;
    width: 18%;
}
.Footer-navbar {
    width: 80%;
    overflow: hidden;
    user-select: none;
    float: left;
}
.Footer-navbar li {
    float: left;
    width: 25%;
}
.Footer-link {
    float: left;
    width: 100%;
    display: flex;
    font-size: 13px;
    color: #99aabe;
}
.Footer-link .title {
    width: 76px;
    white-space: nowrap;
}
.Footer-link ul {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    flex: 1;
}
.Footer-link li {
    margin-left: 10px;
}
.Footer-link li a:hover {
    color: #FFFFFF;
}

.Footer-drop a {
    display: block;
    font-size: 14px;
    color: #99aabe;
    line-height: 1;
    padding: 7px 0;
    transition: all .4s ease;
}
.Footer-drop a:hover {
    color: #FFFFFF;
}
.Footer-menu {
    font-size: 18px;
    color: #fff;
    display: block;
}
.Footer-rel p {
    font-size: 14px;
    color: #99aabe;
    line-height: 1;
}
.fs20 {
    font-size: 20px;
}
.FooterCode a {
    display: inline-flex;
    vertical-align: middle;
    position: relative;
    align-items: center;
    justify-content: center;
    background: #1c335a;
    border-radius: 50%;
    transition: background-color .4s ease;
    width: 40px;
    text-align: center;
    margin: 0 5px;
    height: 40px;
}
.FooterCode a:hover {
    background-color: #000000;;
}
.FooterCode a>img {
    width: 22px;
}

.FooterCode-img {
    width: 152px;
    height: 152px;
    padding: 6px;
    position: absolute;
    bottom: 55px;
    left: 50%;
    margin-left: -76px;
    background: #fff;
    border-radius: 4px;
    animation: footercode-img .6s ease-in-out both;
}
.FooterCode-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.FooterCode-img::after {
    content: "";
    display: block;
    width: 0px;
    height: 0px;
    border: 8px solid transparent;
    border-top-color: #fff;
    position: absolute;
    bottom: -16px;
    left: 42%;
}
@keyframes footercode-img {
    0% {
        transform: translateY(-14px);
    }
    100% {
        transform: translateY(0px);
    }
}

.Footer-copyright {
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding: 24px 0;
    color: #99aabe;
    line-height: 18px;
    font-size: 13px;
}
.contain {
    margin: 0 auto;
    width: 1200px;
}
.Footer-copyright h6 {
    float: left;
    margin: 0;
}
.Footer-page {
    float: right;
}
</style>